import React, { Component } from "react";

import _str from "shared/util/_str";
import Popover, { DIRECTIONS, SIZES, THEMES } from "shared/components/Popover/index";

import "./CardCvvHelp.scss";

class CardCvvHelp extends Component {
	state = {
		showPopover: false,
	};

	componentDidMount() {
		if (this.el) {
			this.el.addEventListener("mouseenter", this.togglePopover);
			this.el.addEventListener("mouseleave", this.togglePopover);
		}
	}

	componentWillUnmount() {
		if (this.el) {
			this.el.removeEventListener("mouseenter", this.togglePopover);
			this.el.removeEventListener("mouseleave", this.togglePopover);
		}
	}

	togglePopover = () => {
		this.setState({ showPopover: !this.state.showPopover });
	}

	render() {
		return (
			<span className="payment-credit-purchase-cvv-help" ref={(el) => { this.el = el; }}>
				<Popover
					hide={!this.state.showPopover}
					title={_str("The CVV is a 3-digit code on the back of your card. On Amex, it’s a 4-digit code on the front.")}
					arrowDirection={DIRECTIONS.DOWN}
					size={SIZES.SMALL}
					theme={THEMES.DARK_GRAY}
				/>
			</span>
		);
	}
}

export default CardCvvHelp;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CardCvvHelp.jsx